import api from '../api'
export default {
	namespaced: true,
	state: {
		voluntList: [],
		voluntTotal: ''
	},
	mutations: {
		appList( state, data = {} ) {
			console.log(data)
			state.voluntList = data.records
			state.voluntTotal = data.total
		}
	},
	actions: {
		appList( { commit, dispatch },  config ) {
			return api.getvoluntList( config ).then(( res ) => {
				commit( 'appList', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		appList_DETAIL ({ commit, dispatch }, config) {
			return api.voluntDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_appList ({ commit, dispatch }, params) {
			return api.deletevolunt({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_appList ({ commit, dispatch }, config) {
			return api.addvolunt(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_appList ({ commit, dispatch }, config) {
			return api.updatevolunt(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/appointment/store/index.js